import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import reduxConnectContainer from './Deviousness.container';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { default as Deviousness, Props as WidgetProps } from './Deviousness';

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);
export interface State {
  showDeviationPicker: boolean;
}
class DeviousnessBox extends React.Component<
  WidgetProps & WidgetBoxProps & WithTranslation,
  State
> {
  state: State = {
    showDeviationPicker: false,
  };
  render() {
    const {
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        moduleId={props.moduleId}
        header={props.t('widgets.deviousness.header')}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        autoShowWidgetConfig={true}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
      >
        <Deviousness {...props} />
      </WidgetBox>
    );
  }
}

export default enhance(DeviousnessBox) as React.ComponentType<{}>;
